import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import axios from 'axios';

function OAuthCallback() {
  const [searchParams] = useSearchParams();
  const { setAuth } = useAuth();
  const navigate = useNavigate();
  const [error, setError] = useState('');
  const hasProcessed = useRef(false); // Prevent double execution

  useEffect(() => {
    // Prevent running twice (React StrictMode issue)
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const sessionId = searchParams.get('session');
    const urlError = searchParams.get('error');

    if (urlError) {
      setError(urlError);
      setTimeout(() => navigate('/'), 3000);
      return;
    }

    if (sessionId) {
      // Fetch auth data from backend session
      axios.get(`/api/auth/session/${sessionId}`)
        .then(response => {
          const authData = response.data;
          setAuth(authData);
          navigate('/');
        })
        .catch(err => {
          console.error('Session fetch error:', err);
          setError('Session expired or invalid. Please try logging in again.');
          setTimeout(() => navigate('/'), 3000);
        });
    } else {
      setError('Authentication failed. No session found.');
      setTimeout(() => navigate('/'), 3000);
    }
  }, [searchParams, setAuth, navigate]);

  return (
    <div className="main-content" style={{ textAlign: 'center', padding: '50px' }}>
      {error ? (
        <>
          <h2 style={{ color: '#e74c3c' }}>❌ {error}</h2>
          <p>Redirecting to home page...</p>
        </>
      ) : (
        <>
          <h2>🔄 Completing authentication...</h2>
          <p>Please wait while we finish setting up your session.</p>
        </>
      )}
    </div>
  );
}

export default OAuthCallback;

